import { render, staticRenderFns } from "./flight-result.vue?vue&type=template&id=03b2ce48&"
import script from "./flight-result.vue?vue&type=script&lang=js&"
export * from "./flight-result.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports